<template>
  <div style="margin-top: 70px">
    <v-container class="mt-5">
      <v-layout text-center wrap>
        <v-flex xs12>
          <v-flex>
            <v-card
              class="ma-auto pa-2"
              flat
              filled
              style="
                  border-radius: 26px;
                  border: 1px solid #18CAE6;
                  max-width: 600px;
                  
                "
            >
              <v-card-title>
                CREATE
                <span class="red--text">MATTER</span>
              </v-card-title>
              <v-form class="ma-2" @submit.prevent="onCreateMatter">
                <div>
                  <!-- <v-card
                    style="
                        border-radius: 26px;
                        max-width: 500px;
                       
                      "
                    tile
                    rounded
                    class="ma-auto"
                    dense
                  > -->
                  <v-text-field
                    label="CASE NAME"
                    name="caseName"
                    validate-on-blur
                    required
                    id="caseName"
                    class="ma-2"
                    v-model="caseName"
                    autofocus
                    clearable
                    dense
                    filled
                    color="#2E5473"
                    outlined
                  ></v-text-field>
                  <v-checkbox
                    label="Have You Filed A complaint?"
                    v-model="complaintFiled"
                    value="true"
                    color="#2E5473"
                  ></v-checkbox>

                  <v-expand-transition>
                    <v-text-field
                      label="WHEN DID YOU FILE THE COMPLAINT?"
                      name="caseNumber"
                      validate-on-blur
                      required
                      id="dateOfComplaint"
                      class="ma-2"
                      filled
                      v-model="dateOfComplaint"
                      clearable
                      dense
                      v-mask="dateMask"
                      v-if="complaintFiled"
                      hint="MM/DD/YYYY"
                      persistent-hint
                      color="#2E5473"
                      outlined
                    ></v-text-field>
                  </v-expand-transition>
                  <v-expand-transition>
                    <v-text-field
                      label="CASE NUMBER"
                      name="caseNumber"
                      validate-on-blur
                      required
                      id="caseNumber"
                      class="ma-2"
                      filled
                      v-model="caseNumber"
                      clearable
                      dense
                      v-if="complaintFiled"
                      color="#2E5473"
                      outlined
                    ></v-text-field>
                  </v-expand-transition>
                  <v-text-field
                    v-model="dateOfLoss"
                    label="DATE OF LOSS"
                    name="dateOfLoss"
                    validate-on-blur
                    required
                    id="dateOfLoss"
                    class="ma-2"
                    filled
                    clearable
                    color="#2E5473"
                    outlined
                    dense
                    v-mask="dateMask"
                    hint="MM/DD/YYYY"
                    persistent-hint
                  ></v-text-field>
                  <v-select
                    label="Statute of Limitations (YEARS)"
                    name="sol"
                    validate-on-blur
                    required
                    id="sol"
                    class="ma-2"
                    filled
                    v-model="statuteOfLimitations"
                    clearable
                    chips
                    deletable-chips
                    :items="statuteTerms"
                    dense
                  ></v-select>

                  <v-text-field
                    label="Deadline to File Complaint (CA)"
                    name="tempComplaintDeadline"
                    validate-on-blur
                    required
                    id="complaintDeadline"
                    class="ma-2"
                    filled
                    v-model="tempComplaintDeadline"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>
                  <!-- causes of actions -->

                  <form @submit.prevent="addCauseOfAction">
                    <v-layout row wrap class="ma-2">
                      <v-text-field
                        class="ma-auto"
                        label="ADD CAUSES OF ACTION"
                        v-model="causeOfAction"
                        clearable
                        name="causeOfAction"
                        validate-on-blur
                        required
                        id="causeOfAction"
                        filled
                        dense
                        style="max-width: 400px"
                        color="#2E5473"
                        outlined
                      ></v-text-field>
                      <v-btn
                        fab
                        small
                        color="green"
                        filled
                        @click="addCauseOfAction"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-layout>
                    <v-list
                      two-line
                      class="ma-auto"
                      style="
                            border: 1px dashed red;
                            max-width: 400px;
                            max-height: 40px;
                            border-radius: 10px;
                          "
                      v-for="(cause, index) in causesOfAction"
                      :key="index"
                    >
                      <v-layout row wrap>
                        <div class="subheading body-1 font-weight-bold ml-4">
                          #{{ index + 1 }}: {{ cause }}
                        </div>
                        <v-spacer></v-spacer>
                        <v-icon color="red darken-2" @click="removeCause(index)"
                          >mdi-minus-circle</v-icon
                        >
                      </v-layout>
                    </v-list>
                  </form>
                  <v-checkbox
                    label="MARK IF THIS IS THIS A COORDINATION PROCEEDING"
                    v-model="coordinationProceeding"
                    color="#2E5473"
                  ></v-checkbox>
                  <v-expand-transition>
                    <v-text-field
                      label="SPECIAL TITLE OF COORDINATION PROCEEDING"
                      name="specialTitle"
                      validate-on-blur
                      id="specialTitle"
                      class="ma-2"
                      filled
                      v-model="specialTitle"
                      clearable
                      dense
                      v-if="coordinationProceeding"
                      color="#2E5473"
                      outlined
                    ></v-text-field>
                  </v-expand-transition>
                  <v-text-field
                    label="JURISDICTION STATE"
                    name="jdxState"
                    validate-on-blur
                    required
                    id="jdxState"
                    class="ma-2"
                    filled
                    v-model="jdxState"
                    clearable
                    dense
                    outlined
                    color="#2E5473"
                  ></v-text-field>
                  <v-text-field
                    label="JURISDICTION COUNTY and DISTRICT"
                    name="jdxCounty"
                    validate-on-blur
                    required
                    id="jdxCounty"
                    class="ma-2"
                    filled
                    v-model="jdxCounty"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>

                  <v-text-field
                    label="COURTHOUSE NAME (OPTIONAL)"
                    name="jdxCourtHouseName"
                    validate-on-blur
                    required
                    id="jdxCourtHouseName"
                    class="ma-2"
                    filled
                    v-model="jdxCourtHouseName"
                    clearable
                    dense
                    color="#2E5473"
                  ></v-text-field>

                  <v-text-field
                    label="COURTHOUSE STREET ADDRESS (OPTIONAL)"
                    name="jdxCourtHouseStreetAddressLine1"
                    validate-on-blur
                    required
                    id="jdxCourtHouseStreetAddressLine1"
                    class="ma-2"
                    filled
                    v-model="jdxCourtHouseStreetAddressLine1"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>
                  <!-- <v-text-field
                        label="COURTHOUSE STREET ADDRESS (OPTIONAL)"
                        name="jdxCourtHouseStreetAddressLine1"
                        validate-on-blur
                        required
                        id="jdxCourtHouseStreetAddressLine1"
                        class="ma-2"
                        filled
                        v-model="jdxCourtHouseStreetAddressLine1"
                        clearable
                        dense
                      ></v-text-field>-->

                  <v-text-field
                    label="COURTHOUSE CITY (OPTIONAL)"
                    name="jdxCourtHouseCity"
                    validate-on-blur
                    required
                    id="jdxCourtHouseCity"
                    class="ma-2"
                    filled
                    v-model="jdxCourtHouseCity"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>

                  <v-text-field
                    label="COURTHOUSE STATE (OPTIONAL)"
                    name="jdxCourtHouseState"
                    validate-on-blur
                    required
                    id="jdxCourtHouseState"
                    class="ma-2"
                    filled
                    v-model="jdxCourtHouseState"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="COURTHOUSE ZIP (OPTIONAL)"
                    name="jdxCourtHouseZip"
                    validate-on-blur
                    required
                    id="jdxCourtHouseZip"
                    class="ma-2"
                    filled
                    v-model="jdxCourtHouseZip"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="DEPARTMENT (OPTIONAL)"
                    name="jdxDepartment"
                    validate-on-blur
                    required
                    id="jdxDepartment"
                    class="ma-2"
                    filled
                    v-model="jdxDepartment"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    label="JUDGE (OPTIONAL)"
                    name="jdxJudge"
                    validate-on-blur
                    required
                    id="jdxJudge"
                    class="ma-2"
                    filled
                    v-model="jdxJudge"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>

                  <v-select
                    label="STATUS"
                    name="status"
                    validate-on-blur
                    required
                    id="status"
                    class="ma-2"
                    filled
                    v-model="status"
                    clearable
                    chips
                    deletable-chips
                    :items="statuses"
                    height="50px"
                    dense
                    color="#2E5473"
                    outlined
                  ></v-select>

                  <v-text-field
                    label="INTERNAL ID"
                    name="id"
                    validate-on-blur
                    required
                    id="id"
                    class="ma-2"
                    filled
                    v-model="internalID"
                    clearable
                    dense
                    color="#2E5473"
                    outlined
                  ></v-text-field>

                  <!-- <div class="ma-2">
                        <v-file-input
                          filled
                          chips
                          multiple
                          label="Upload Initial Documents"
                          ref="fileInput"
                          @change="onFilePicked"
                          dense
                        ></v-file-input>
                      </div>
                      <v-card>
                        <ol class="ma-auto">
                          <li v-for="(file, index) in initialDocs" :key="index">
                            <v-layout>
                              <div class="ma-auto">{{file.name}}</div>
                              <v-btn small text rounded @click="removeFile(index)">
                                <v-icon color="red">mdi-minus-circle</v-icon>
                              </v-btn>
                            </v-layout>
                          </li>
                        </ol>
                      </v-card>-->

                  <!-- </v-card> -->
                </div>
                <v-layout row class="mt-2">
                  <v-spacer></v-spacer>
                  <v-btn rounded text filled @click="goHome">CANCEL</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    rounded
                    color="green"
                    outlined
                    :disabled="!formIsValid"
                    type="submit"
                    >SUBMIT</v-btn
                  >
                  <v-spacer></v-spacer>
                </v-layout>
              </v-form>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
/**
 * this component allows the user to create a matter
 * this component needs some work,
 * some matter data properties need to be added and or changed
 */
import * as moment from "moment";
import { mask } from "vue-the-mask";

import slugify from "slugify";
export default {
  directives: {
    mask
  },
  data: () => ({
    //
    caseName: null,
    caseNumber: null,
    dateOfLoss: null,
    internalID: null,
    dateOfComplaint: null,
    causeOfAction: null,
    causesOfAction: [],
    coordinationProceeding: false,
    specialTitle: null,
    status: null,
    menu: false,
    statuses: ["steady", "complete", "urgent", "steady"], // need to change to pre-lit, suit filed, trial... etc.
    initialDocs: [],
    matterSlug: null,
    jdxState: "CALIFORNIA",
    jdxCounty: "LOS ANGELES - CENTRAL",
    jdxCourtHouseName: "Spring Street Courhouse",
    jdxCourtHouseStreetAddressLine1: "111 Spring St.",
    statuteTerms: [1, 2, 3, 4],
    statuteOfLimitations: null,
    tempComplaintDeadline: null,
    dateMask: "##/##/####",
    complaintFiled: false,

    jdxCourtHouseCity: "Los Angeles",
    jdxCourtHouseState: "CA",
    jdxCourtHouseZip: "90012",
    jdxDepartment: null,
    jdxJudge: null,
    firm: null
  }),
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    complaintDeadline(val) {
      if (this.dateOfLoss !== null && this.dateOfLoss !== undefined) {
        this.tempComplaintDeadline = val;
      }
    }
    // dateOfComplaint(val) {
    //   let formatedDate = moment(val).format("MMMM Do YYYY");
    //   console.log(formatedDate);
    // }
    // watch the newMatter object
    // user(val) {
    //   console.log("user from creatematter watch", val);
    // }
  },
  computed: {
    formattedDateOfLoss() {
      if (this.dateOfLoss !== null && this.dateOfLoss !== undefined) {
        let date = moment(this.dateOfLoss).format("YYYY-MM-DD");
        console.log("formattedDateOfLoss", date);
        return date;
      } else {
        return null;
      }
    },
    formIsValid() {
      return (
        this.caseName !== null &&
        this.dateOfLoss !== null &&
        this.status !== null
      );
    },
    complaintDeadline() {
      if (
        this.statuteOfLimitations !== null &&
        this.statuteOfLimitations !== undefined
      ) {
        if (this.dateOfLoss !== null && this.dateOfLoss !== undefined) {
          if (this.statuteOfLimitations === 1) {
            let date = moment(`${this.dateOfLoss}`)
              .add(1, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else if (this.statuteOfLimitations === 2) {
            let date = moment(`${this.dateOfLoss}`)
              .add(2, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else if (this.statuteOfLimitations === 3) {
            let date = moment(`${this.dateOfLoss}`)
              .add(3, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else if (this.statuteOfLimitations === 4) {
            let date = moment(`${this.dateOfLoss}`)
              .add(4, "year")
              .format("LL");
            // this.tempComplaintDeadline = date;
            return date;
          } else {
            return null;
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    // firm() {
    //   this.$store.dispatch("getFirm", data);
    //   return this.$store.getters.firm;
    // },
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    addCauseOfAction() {
      this.causesOfAction.push(this.causeOfAction.toUpperCase());

      this.causeOfAction = null;
    },
    removeCause(index) {
      this.causesOfAction.splice(index, 1);
    },
    onCreateMatter() {
      console.log("firm", this.firm);
      if (!this.formIsValid) {
        return;
      }
      let alias =
        this.caseName + " " + moment(`${this.dateOfLoss}`).format("YYYY-MM-DD");
      this.matterSlug = slugify(alias, {
        replacement: "-",
        remove: /[$*_+~.()'"!\-:@,]/g,
        lower: true
      });
      console.log("formattedDateOfLoss", this.formattedDateOfLoss);

      const newMatter = {
        // dateOfLoss: this.formattedDateOfLoss,

        data: {
          caseName: this.caseName.trim(),
          caseNumber: this.caseNumber,
          dateOfLoss: moment(`${this.dateOfLoss}`).format("YYYY-MM-DD"),
          statuteOfLimitations: `${
            this.statuteOfLimitations
              ? this.statuteOfLimitations.toString()
              : null
          }`,
          complaintDeadline: this.tempComplaintDeadline,
          dateOfComplaint: moment(`${this.dateOfComplaint}`).format(
            "MMMM Do YYYY"
          ),
          internalID: this.internalID,
          causesOfAction: this.causesOfAction,
          coordinationProceeding: this.coordinationProceeding,
          specialTitle: this.specialTitle,
          status: this.status,
          dateCreated: moment().format("MMMM Do YYYY, h:mm:ss a"),
          creatorID: this.$store.getters.user.email,
          notes: [],
          activities: [],
          attorneys: [],
          matterSlug: this.matterSlug,
          jdxState: this.jdxState,
          jdxCounty: this.jdxCounty,
          jdxCourtHouseName: this.jdxCourtHouseName,
          jdxCourtHouseStreetAddressLine1: this.jdxCourtHouseStreetAddressLine1,
          jdxCourtHouseCity: this.jdxCourtHouseCity,
          jdxCourtHouseState: this.jdxCourtHouseState,
          jdxCourtHouseZip: this.jdxCourtHouseZip,
          jdxDepartment: this.jdxDepartment,
          jdxJudge: this.jdxJudge,
          caseDocs: {
            initialDocs: []
          },
          plaintiffs: [],
          defendants: [],
          sharedWith: [this.$store.getters.user.email],
          firms: [
            {
              firmAddressLine: this.user.firmAddressLine,
              firmCityStateZip: this.user.firmCityStateZip,
              firmFax: this.user.fax,
              firmName: this.user.firmName,
              firmPhone: this.user.phone,
              firmSlug: this.user.firmSlug
              // userlist: this.firm.userlist
            }
          ],
          events: [],
          trialDate: null
        },
        firmSlug: this.$store.getters.user.firmSlug

        // initialDocs: this.initialDocs
      };
      console.log(newMatter);
      this.$store.dispatch("createMatter", newMatter);
      this.$router.push(`/matters/${this.matterSlug}`);
    },
    goHome() {
      this.$router.push("/");
    }
    // onFilePicked() {
    //   if (event.target.files) {
    //     // console.log(event.target.files)
    //     const fileList = Array.from(event.target.files);
    //     // console.log("fileList: ", fileList)

    //     fileList.forEach(file => {
    //       this.initialDocs.push(file);
    //     });
    //     // this.fileList = []
    //   }
    // },
    // removeFile(index) {
    //   this.initialDocs.splice(index, 1);
    // }
  }
};
</script>

<style scoped></style>
